import { QueryKeys } from '@shared/domain/queryKeys'
import { useApiClient } from '@shared/hooks/useApiClient'
import { useQuery } from '@tanstack/react-query'
import type { Category } from '../domain/Bet.domain'

export const useGetCategories = () => {
  const api = useApiClient()

  return useQuery({
    queryKey: [QueryKeys.Categories],
    queryFn: async () => {
      const response = await api.get<Category[]>('/categories')
      return response.data
    },
  })
}
